// extracted by css-extract-rspack-plugin
export default {"NoResultsTableRow":"K_DH8","SkeletonTableRow":"eNGux","CacheableItemTable":"Cvvh3","currentTarget":"nnKPl","StrategyFormPanel":"YBAW_","ItemLink":"n2Fqx","CollectionLink":"DXVlH"};